// ../shared/utils/dist/src/helpers.js
function isNumeric(n) {
  const v = typeof n != "string" || n === "" ? n : Number(n);
  const f = parseFloat(n);
  return !isNaN(f) && Number.isFinite(v) && v === f;
}
function isStrictNumeric(n) {
  return typeof n === "number" && Number.isFinite(n);
}
function convertUnits(v, fromUnit, toUnit, scaleFactor, compact) {
  if (scaleFactor >= 1) {
    const toUnitV2 = Math.floor(v * scaleFactor);
    if (compact) return `${toUnitV2}${toUnit.charAt(0)}`;
    return `${toUnitV2} ${toUnitV2 > 1 ? toUnit + "s" : ""}`;
  }
  const toUnitV = Math.floor(v * scaleFactor);
  const fromUnitV = Math.ceil(v % (1 / scaleFactor));
  if (fromUnitV == 0) {
    if (compact) return `${toUnitV}${toUnit.charAt(0)}`;
    return `${toUnitV} ${toUnitV > 1 ? toUnit + "s" : ""}`;
  }
  if (compact) return `${toUnitV}${toUnit.charAt(0)}${fromUnitV}${fromUnit.charAt(0)}`;
  return `${toUnitV} ${toUnitV > 1 ? toUnit + "s" : toUnit} ${fromUnitV} ${fromUnitV > 1 ? fromUnit + "s" : fromUnit}`;
}
function getValueConversionFactor(term) {
  const f = Number(term?.valueConversion?.scaleFactor);
  return Number.isFinite(f) && f > 0 ? f : 1;
}
function toUserUnit(v, term, digits = 2) {
  if (!isConvertible(v, term)) return v;
  return Number((Number(v) * getValueConversionFactor(term)).toFixed(digits));
}
function toStoredUnit(v, term) {
  if (!isConvertible(v, term)) return v;
  return Number(v) / getValueConversionFactor(term);
}
function isConvertible(v, term) {
  if (getValueConversionFactor(term) == 1) return false;
  if (v === "" || v === null || v === void 0) return false;
  return Number.isFinite(Number(v));
}
function uiLabel(uiLabels, key, fallback) {
  const v = uiLabels?.[key];
  if (typeof v == "string") return v;
  if (v && typeof v.label == "string") return v.label;
  return fallback;
}
var CustomError = class extends Error {
  constructor(message, opts = {}) {
    super(message);
    this.level = "";
    if (opts.name) this.name = opts.name;
    if (opts.code) this.code = opts.code;
    if (opts.level) this.level = opts.level;
  }
};

export {
  isNumeric,
  isStrictNumeric,
  convertUnits,
  getValueConversionFactor,
  toUserUnit,
  toStoredUnit,
  uiLabel,
  CustomError
};
//# sourceMappingURL=chunk-W5J3LTYS.js.map
